import httpClient from './httpClient';

export interface ServerVersionDto {
  version: string;
  releasedAt: string;
  notes?: string | null;
}

export const versionApi = {
  get: async (): Promise<ServerVersionDto> => {
    const { data } = await httpClient.get<ServerVersionDto>('/version');
    return data;
  },
};
